import { useEffect, useState } from "react";
import { customSessionStorage } from "@crehana/utils";
const KEY_WEBVIEW_STATE = 'creh-is-in-web-view';
const checkQueryParameter = ()=>{
    const params = new URLSearchParams(window.location.search);
    return 'true' === params.get('from-webview') || 'true' === params.get('isFromApps');
};
const detectWebView = ()=>{
    if ("u" < typeof window) return {
        isWebView: false
    };
    const storedValue = customSessionStorage.getItem(KEY_WEBVIEW_STATE);
    if (storedValue) {
        const data = JSON.parse(storedValue);
        if (data.origin === window.location.origin) return {
            isWebView: data.isWebView
        };
        customSessionStorage.removeItem(KEY_WEBVIEW_STATE);
        return {
            isWebView: false
        };
    }
    if (checkQueryParameter()) {
        const result = {
            isWebView: true
        };
        if (result.isWebView) {
            const state = {
                isWebView: true,
                origin: window.location.origin
            };
            customSessionStorage.setItem(KEY_WEBVIEW_STATE, JSON.stringify(state));
        }
        return result;
    }
    return {
        isWebView: false
    };
};
const getInitialState = ()=>{
    if ("u" < typeof window) return false;
    return detectWebView().isWebView;
};
const useIsRenderedFromWebView = ()=>{
    const [isWebView, setIsWebView] = useState(getInitialState);
    useEffect(()=>{
        const detection = detectWebView();
        setIsWebView(detection.isWebView);
    }, []);
    return isWebView;
};
export { useIsRenderedFromWebView };
